import React, { useEffect } from "react";

import { formatCurrency, formatString } from "../../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";

const moment = require("moment");

export default function Payout({ payout, bankAccount, handleView, colSpan }) {
  return (
    <tr className="with-inside-borders">
      <td colSpan={colSpan}>
        <Stack gap={1}>
          <span className="caption caption-bold">
            {bankAccount?.data[0]?.bank_name}
          </span>
          <span className="caption fw-normal">
            Est. Arrival{" "}
            {moment
              .unix(payout?.arrival_date)
              .add(1, "day")
              .format("MMM Do YYYY")}{" "}
          </span>
        </Stack>
      </td>
      <td colSpan={2}>{formatCurrency(payout?.amount / 100)}</td>
      <td colSpan={2}>
        <Badge
          bg="none"
          className={`m-auto w-max-content badge--${payout?.status}`}
        >
          {formatString(payout?.status)}
        </Badge>
      </td>
      <td className="text-center">
        <Button
          variant="outline-light"
          size="sm"
          onClick={(e) => handleView(e, payout)}
        >
          View
        </Button>
      </td>
    </tr>
  );
}
